import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import * as styles from './style';
import VariationOptionItem from './VariationOptionItem';
import InputCurrency from '../InputCurrency';
import Input from '../Input';

const VariationOptionForm = ({
  options,
  form,
  errors,
  atLeastOneError,
  onSubmit,
  onChange,
  currentEditingId,
  onEdit,
  onRemove,
  onPriceChange,
  onCancelEdit,
}) => {
  const [currItemEdited, setCurrItemEdited] = useState('');
  useEffect(() => {
    if (currentEditingId !== currItemEdited) {
      setCurrItemEdited(currItemEdited);
      document.getElementById('variation-option-name').focus();
    }
  }, [currentEditingId, currItemEdited]);

  const editing = !!currentEditingId;
  return (
    <styles.Box onSubmit={onSubmit}>
      <styles.StyledFormGroup error={errors.name.isInvalid}>
        <label>Opção da variação</label>
        <Input
          id="variation-option-name"
          name="name"
          onChange={onChange}
          value={form.name}
          placeholder="Ex: Marguerita, Superfamília etc."
          maxLength="30"
        />
      </styles.StyledFormGroup>

      <styles.StyledFormGroup>
        <label>Descrição</label>
        <textarea name="desc" onChange={onChange} value={form.desc} maxLength="200" />
      </styles.StyledFormGroup>

      <styles.StyledRow editing={editing}>
        <styles.StyledFormGroup>
          <label>Cód. do Produto</label>
          <Input name="sku" onChange={onChange} value={form.sku} maxLength="20" />
        </styles.StyledFormGroup>

        <styles.StyledFormGroup error={errors.originalPrice.isInvalid}>
          <label>Preço</label>
          <InputCurrency name="originalPrice" onChange={onPriceChange} value={form.originalPrice} />
        </styles.StyledFormGroup>
        <styles.InvertContainer>
          <Button
            className="save-option-variation"
            onClick={e => e.stopPropagation()}
            type="submit"
            height="40px"
            width={editing ? '100px' : '155px'}
            customStyles={{
              lineHeight: '2px',
              whiteSpace: 'nowrap',
              marginLeft: 'auto',
            }}
          >
            {editing ? 'Salvar' : 'Salvar Opção'}
          </Button>
          {editing && (
            <Button
              noHover
              link
              onClick={onCancelEdit}
              className="cancel-option-variation"
              height="40px"
              width="100px"
              type="button"
              bgColor="white"
              border="none"
            >
              Cancelar
            </Button>
          )}
        </styles.InvertContainer>
      </styles.StyledRow>

      <styles.Divisor />

      <styles.ListTitle>Opções Cadastradas</styles.ListTitle>

      <styles.OptionList atLeastOneError={atLeastOneError}>
        {options.map((option, index) => (
          <VariationOptionItem
            index={index}
            key={`${option.name}-${option.originalPrice}`}
            currentEditingId={currentEditingId}
            onEdit={onEdit}
            option={option}
            onRemove={onRemove}
          />
        ))}

        {options.length === 0 && (
          <styles.EmptyMessage>Ainda não há opções cadastradas nesta variação</styles.EmptyMessage>
        )}
      </styles.OptionList>
    </styles.Box>
  );
};

VariationOptionForm.propTypes = {
  options: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  atLeastOneError: PropTypes.bool.isRequired,
  currentEditingId: PropTypes.any,
  onCancelEdit: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onPriceChange: PropTypes.func.isRequired,
};

VariationOptionForm.defaultProps = {
  currentEditingId: '',
};

export default VariationOptionForm;



// WEBPACK FOOTER //
// ./src/components/VariationOptionForm/index.js